/**
 * Settings required to generate one child individual report.
 */
export interface IndividualReportSettingsContract {
  data_set_uuid: string;
}
